import { ReceiptDetails, ReceiptDocumentInvoice } from "@/models/accounting";
import { formatAmount } from "@/util";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface IAccountingReceiptTabProps {
    selectedReceipt: ReceiptDocumentInvoice | null;
    receiptDetails: ReceiptDetails | undefined;
}

const AccountingReceiptTab: FC<IAccountingReceiptTabProps> = (props: IAccountingReceiptTabProps) => {
    const { t } = useTranslation();

    return (
        <div className="accounting-receipt-tab-container">
            <div className="accounting-receipt-tab-header">
                {t("enums.AccountingDocType.Receipt")} #{props.selectedReceipt?.documentNumber}
            </div>
            <div className="accounting-receipt-tab-content">
                <div className="accounting-receipt-tab-content-data">
                    <div className="transaction-tab-text">
                        <div>{t("accounting.connectedInvoicesQTY")}:</div>
                        <div>{t("accounting.documentType")}:</div>
                    </div>
                    <div className="transaction-tab-data">
                        <div>{props.receiptDetails?.connectedInvoicesQty}</div>
                        <div>{t(`enums.AccountingDocType.${props.receiptDetails?.docType}`)}</div>
                    </div>
                </div>
                <div className="accounting-receipt-tab-content-data-second">
                    <div className="transaction-tab-text">
                        <div>{t("accounting.docAmount")}:</div>
                    </div>
                    <div className="transaction-tab-data">
                        <div>{formatAmount(props.selectedReceipt?.total, props.selectedReceipt?.currencyId)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountingReceiptTab;
